import Locale from '../utils/Locale';
import { ContentCategories } from "../types";

/** What access level a user has
 * @see siteShareLevel
 */
export enum userAccessLevel {
    /** Lowest possible level */
    NoAccess = "NoAccess",
    /** Use accessing the site through a partial share */
    SharedPartialAccess = "SharedPartialAccess",
    /** Use accessing the site through a full access share */
    SharedFullAccess = "SharedFullAccess",
    /** Use accessing the site through an administrator share */
    SharedAdminAccess = "SharedAdminAccess",
    /** Use directly uses the site as a maintainer (pool prof) */
    Maintainer = "Maintainer",
    /** Use directly uses the site as his/her own site */
    Owner = "Owner",
}

export const userAccessLevels = [
    { order: 0, label: Locale.gettext('No Access'), value: userAccessLevel.NoAccess },
    { order: 1, label: Locale.gettext('Shared partial access'), value: userAccessLevel.SharedPartialAccess },
    { order: 2, label: Locale.gettext('Shared full access'), value: userAccessLevel.SharedFullAccess },
    { order: 3, label: Locale.gettext('Shared administrator access'), value: userAccessLevel.SharedAdminAccess },
    { order: 4, label: Locale.gettext('Maintainer access'), value: userAccessLevel.Maintainer },
    { order: 5, label: Locale.gettext('Owner access'), value: userAccessLevel.Owner }
];

/**
 * Returns which ContentCategories could be accessible with the given user caess level
 */
export const mapUserAccessLevelToContentCategories = {
    [ userAccessLevel.NoAccess ]: [
        ContentCategories.BASIC,
    ],
    [ userAccessLevel.SharedPartialAccess ]: [
        ContentCategories.BASIC,
        ContentCategories.SHARING,
    ],
    [ userAccessLevel.SharedFullAccess ]: [
        ContentCategories.BASIC,
        ContentCategories.EQUIPMENT_FAILURE,
        ContentCategories.SHARING,
        ContentCategories.SYSTEM_ERROR,
        ContentCategories.SYSTEM_INFO,
        ContentCategories.WATER_FLOW,
        ContentCategories.WATER_LEVELING,
        ContentCategories.WATER_QUALITY,
    ],
    [ userAccessLevel.SharedAdminAccess ]: [
        ContentCategories.BASIC,
        ContentCategories.EQUIPMENT_FAILURE,
        ContentCategories.SHARING,
        ContentCategories.SYSTEM_ERROR,
        ContentCategories.SYSTEM_INFO,
        ContentCategories.WATER_FLOW,
        ContentCategories.WATER_LEVELING,
        ContentCategories.WATER_QUALITY,
    ],
    [ userAccessLevel.Maintainer ]: [
        ContentCategories.BASIC,
        ContentCategories.EQUIPMENT_FAILURE,
        ContentCategories.SHARING,
        ContentCategories.SYSTEM_ERROR,
        ContentCategories.SYSTEM_INFO,
        ContentCategories.WATER_FLOW,
        ContentCategories.WATER_LEVELING,
        ContentCategories.WATER_QUALITY,
    ],
    [ userAccessLevel.Owner ]: [
        ContentCategories.BASIC,
        ContentCategories.EQUIPMENT_FAILURE,
        ContentCategories.SHARING,
        ContentCategories.SYSTEM_ERROR,
        ContentCategories.SYSTEM_INFO,
        ContentCategories.WATER_FLOW,
        ContentCategories.WATER_LEVELING,
        ContentCategories.WATER_QUALITY,
    ]
};
